module.exports = __webpack_public_path__ + "static/media/Weight.5382fd58.svg";